import Vue from 'vue'
import Router from 'vue-router'

import input1 from '@/components/input1'
import input2 from '@/components/input2'
import input3 from '@/components/input3'
import input4 from '@/components/input4'
import result from "@/components/result"


Vue.use(Router)

export default new Router({
    base: 'kodate/guide/simulation/sumai-life',
    mode: 'history',
    routes: [
        {
            path: '/',
            // name: 'input1',
            component: input1,
            meta: {
                title: '世帯主について',
                // desc: 'ディスクリプションを記述'
            },
        },
        {
            path: '/input2',
            // name: 'input2',
            component: input2,
            meta: {title: '配偶者について'},
        },
        {
            path: '/input3',
            component: input3,
            meta: {title: 'お子さまについて'},
        },
        {
            path: '/input4',
            component: input4,
            meta: {title: 'お住まいについて'},
        },
        {
            path: '/result',
            // name: 'result',
            component: result,
        },
    ]
})